module.exports = __webpack_public_path__ + "static/media/yelp.824a229b.png";